/*
 * @Author: your name
 * @Date: 2020-10-13 09:07:49
 * @LastEditTime: 2020-10-30 18:31:25
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \writing_pc\static\js\api.js
 */

import http from "./http";
var writing = {
  list: "api/article/list",
  create: "api/article/create",
  delete: "api/article/delete/",
  detail: "api/article/detail/",
  save: "api/article/save",
  rename: "api/article/rename",
  export: "api/article/export/",
  outline: "api/recommend/outline",
  content: "api/recommend/content",
  import: "api/article/import",
  summary: "api/recommend/summary",
  summaryEn: "api/recommend/summary-en",
  correct: "api/correct/submit",
  correctlist: "api/correct/list",
  checkSubmit: "api/check/submit",
  checkLimit: "api/check/check-limit",
  checkDetail: "api/check/detail",
  checkList: "api/check/list",
  checkPay: "api/check/check-pay",
  database: "api/search/list",
  collect:'api/collect/search',
  refExport:'api/search/ref-export',
  addCollect:'api/collect/add',
  cancelCollect:'api/collect/cancel' ,
  collectDetail:'api/search/detail',
  noteList:'api/note/note-list',
  noteDoc:'api/note/note-add-doc',
  labelList:'api/note/label-list',
  labelAdd:'api/note/label-add',
  addnote:'api/note/note-add',
  noteClear:'api/note/note-clear',
  noteDelete:'api/note/note-delete',
  upload:'oauth-api/api/uc/avatar/ossconfig',
  modefyUser:'oauth-api/api/uc/modify/user',
  mobileold:'oauth-api/api/uc/change/mobile/valid/old',
  createLogin : 'api/article/create-example',
  example:'api/article/article-example',
  realDrop:'api/check/real-drop',
  cancel:'api/check/cancel',
  pdfView: 'api/search/pdf-view',
  noteUpdate:'api/note/note-update',

  siteLogo: 'api/system/server-config/attribute/logo',
  navigationHead: 'api/system/server-config/attribute/navigation-head',
  navigationUser: 'api/system/server-config/attribute/navigation-user',
  indexPage: 'api/system/server-config/attribute/byCode',

  toolsLimitCheck: 'api/toolsLimit/check',
  guideLimit: 'api/toolsLimit/guide-limit',

  //充值，会员
  vipProduct: 'api/vip/get/product',
  vipUserScrollInfo: 'api/vip/user-scroll/info',
  vipCreate: 'api/vip/create',
  pointPayOrder: 'api/vip/point-pay-create',
  vipState: 'api/vip/getOrderState',

  rechargeConfig: 'api/pay/academic-recharge-config',
  rechargeCreate: 'api/pay/academic-recharge-order',
  rechargeState: 'api/pay/academic-order-state'
}

/**
 * 获取用户写作列表
 * @param {Number} size 每页条数
 * @param {Number} current 当前页数
 */
function getWritinglist(params) {
  return http.get(writing.list, params);
}
/**
 * 新建论文
 * @param {String} title 论文标题
 *
 */
function create(params) {
  return http.post(writing.create, params);
}

/**
 *删除论文
 * @param {Number} articleId 论文主键 字段为id
 */
function deleteWriting(params) {
  return http.get(writing.delete + params);
}
/**
 *获取论文详情
 * @param {Number} articleId 论文主键 字段为id
 */
function detail(params) {
  return http.get(writing.detail + params);
}
/**
 * 保存论文
 * @param {*} articleId 论文id
 * @param {String} content 论文内容
 * @param {String} title 论文标题
 */
function save(params) {
  return http.post(writing.save, params);
}
/**
 * 修改标题
 * @param {*} id 论文ID
 * @param {String} title 论文标题
 */
function rename(params) {
  return http.post(writing.rename, params);
}
/**
 * 导出论文
 * @param {*} 论文id
 */
function dowWriting(params) {
  http.dow(writing.export + params);
}

/**
 * 上传文件
 */
function upfile(params) {
  // console.log(params);
  return http.upfile(writing.import, params);
}

/**
 * 推荐论文
 * @param {String} title 论文标题
 */
function outline(params) {
  return http.post(writing.outline, params);
}

/**
 * 推荐思路
 * @param content  截取的正文内容,
 * @param title  论文标题
 */
function getThinking(params) {
  return http.post(writing.content, params);
}

/**
 * 推荐摘要/致谢
 * @param {String} title 论文标题
 * @param {*} type 推荐类型 1：摘要 2:致谢
 */
function getsummary(params) {
  return http.post(writing.summary, params);
}

/**
 * 摘要翻译
 */
function summaryEn(params) {
  return http.post(writing.summaryEn, params);
}
/**
 * 论文纠错
 * @param articleId 论文id
 */
function correct(params) {
  return http.post(writing.correct, params);
}

/**
 * 纠错列表
 * @param {*} params
 */

function correctList(params) {
  return http.get(writing.correctlist, params);
}
/**
 * 论文查重提交
 * @param {*} params
 */
function checkSubmit(params) {
  return http.post(writing.checkSubmit, params);
}
/**
 * 查重限制次数查询
 * @param {*} params
 */
function checkLimit(params) {
  return http.get(writing.checkLimit, params);
}
/**
 * 最近一条查重
 * @param {*}  论文ID
 */
function checkDetail(params) {
  return http.get(writing.checkDetail, params);
}
/**
 * 查重记录列表
 * @param {} articleId 论文id
 * @param {} current 当前页
 * @param {} size 每页条数
 */
function checkList(params) {
  return http.get(writing.checkList, params);
}

/**
 *查重支付
 *
 * @param {*} params
 * @returns
 */
function checkPay(params) {
  return http.get(writing.checkPay, params);
}

/**
 * @param  content 输入内容
 * @param  current 当前页
 * @param  size 每页显示条数 默认 10
 * @param  timeSort 时间排序 true: 按照时间降序排序 false: 不启用时间排序 与相关度互斥
 * @param  type 搜索类型 0:全部 1:期刊 2:论文
 */
function getdatabase(params) {
  return http.post(writing.database, params);
}
/**
 * 资料库收藏列表
 * @param {*} params
 */
function getCollect(params){
    return http.get(writing.collect, params);
}
/**
 * 文献引用
 * @param {*} docId 文献id
 */
function refExport(params){
    return http.get(writing.refExport, params);
}

/**
 * 添加收藏
 */
function addCollect(params){
  return http.post(writing.addCollect, params);
}

/**
 * 取消收藏
 */
function cancelCollect(params) {
  return http.get(writing.cancelCollect, params);
}
/**
 * 资料详情
 * @param {*} params
 */
function collectDetail(params) {
  return http.get(writing.collectDetail, params);
}

/**获取资料详情的内容 */
 function gethtml(params) {
  return http.get(params);
 }

/**
 * 用户笔记列表
 */
function noteList(params) {
  return http.get(writing.noteList, params);
}

/**
 * 资料库中添加笔记
 * @param {*} params
 */
function noteDoc(params) {
  return http.post(writing.noteDoc,params)
}
/**
 * 用户使用过的标签列表
 */
function labelList(params) {
  return http.get(writing.labelList, params);
}
/**
 * 添加标签
 */
function labelAdd(params) {
  return http.post(writing.labelAdd,params)
}


/**
 * 添加笔记
 */
function addnote(params) {
  return http.post(writing.addnote,params)
}

/**
 * 清除笔记
 * @param {}} params
 */
function noteClear(params) {
  return http.post(writing.noteClear)
}
function noteDelete(params) {
  return http.post(writing.noteDelete,params)
}

/**
 * 用户头像上传
 * @param {}} params
 */
function upload(params) {
  return http.get(writing.upload,params)
}

/**
 * 修改用户信息
 * @param {}} params
 */
function modefyUser(params) {
  return http.post(writing.modefyUser,params)
}

/**
 *验证旧手机号码
 * @param {}} params
 */
function mobileold(params) {
  return http.post(writing.mobileold,params)
}

/**
 *已登录查看示例论文 
 */
function createLogin(params) {
  return http.post(writing.createLogin)
}
/**
 * 未登录查看示例论文
 */
function example(params) {
  return http.post(writing.example)
}

function realDrop(params) {
  return http.post(writing.realDrop,params)
}
/**
 * 取消查重
 */
function cancel(params) {
  return http.get(writing.cancel, params);
}
/**
 * 查看PDF原文
 */
function pdfView(params) {
  return http.get(writing.pdfView, params);
}
/**
 * 修改笔记
 */
function noteUpdate(params) {
  return http.post(writing.noteUpdate,params);
}
/**
 * 获取平台logo
 */
function getSiteLogo() {
  return http.get(writing.siteLogo);
}
/**
 * 获取头部导航栏
 */
function getNavigationHead() {
  return http.get(writing.navigationHead);
}
/**
 * 获取用户导航栏
 */
function getNavigationUser() {
  return http.get(writing.navigationUser);
}
/**
 * 获取业务平台首页地址
 */
function getIndexPage(params) {
  return http.get(writing.indexPage, params);
}

/**
 * 用户操作次数校验（导入，导出，文献查看）
 * @param {params} params 
 */
function getToolsLimitCheck(params) {
  return http.get(writing.toolsLimitCheck, params);
}
/** 用户是否引导 */
function getGuideLimit(params) {
  return http.get(writing.guideLimit, params);
}

/**
 * 获取会员充值列表
 */
function getVipProduct() {
  return http.get(writing.vipProduct);
}
/**
 * 获取会员充值滚动信息
 */
function getVipUserScrollInfo() {
  return http.get(writing.vipUserScrollInfo);
}
/**
 * 创建会员充值订单
 * @param {*} params 
 */
function createVipOrder(params) {
  return http.get(writing.vipCreate, params);
}

/** 余额支付vip订单 */
function  pointPayOrder(params) {
  return http.get(writing.pointPayOrder, params);
}
/**
 * 获取会员订单状态
 * @param {*} params 
 */
function getVipOrderState(params) {
  return http.get(writing.vipState, params);
}
/**
 * 获取学术币充值配置
 */
function getRechargeConfig() {
  return http.get(writing.rechargeConfig);
}
/**
 * 创建学术币充值订单
 * @param {*} params 
 */
function createRechargeOrder(params) {
  return http.get(writing.rechargeCreate, params);
}
/**
 * 获取学书币充值订单状态
 * @param {*} params 
 */
function getRechargeOrderState(params) {
  return http.get(writing.rechargeState, params);
}

export default {
  getWritinglist,
  create,
  deleteWriting,
  detail,
  save,
  rename,
  dowWriting,
  upfile,
  outline,
  getThinking,
  getsummary,
  summaryEn,
  correct,
  correctList,
  checkSubmit,
  checkLimit,
  checkDetail,
  checkList,
  checkPay,
  getdatabase,
  getCollect,
  refExport,
  addCollect,
  cancelCollect,
  collectDetail,
  gethtml,
  noteList,
  noteDoc,
  labelList,
  labelAdd,
  addnote,
  noteClear,
  noteDelete,
  upload,
  modefyUser,
  mobileold,
  createLogin,
  example,
  realDrop,
  cancel,
  pdfView,
  noteUpdate,
  getSiteLogo,
  getNavigationHead,
  getNavigationUser,
  getIndexPage,
  getToolsLimitCheck,
  getGuideLimit,

  getVipProduct,
  getVipUserScrollInfo,
  createVipOrder,
  pointPayOrder,
  getVipOrderState,
  getRechargeConfig,
  createRechargeOrder,
  getRechargeOrderState
};



// WEBPACK FOOTER //
// ./static/js/api.js